import { hooks } from '@febos-io/design';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import meta from '../../package.json';

export function useTranslation() {
  return hooks.useTranslation(meta.name);
}

export default useTranslation;
